import { render, staticRenderFns } from "./resultStats.vue?vue&type=template&id=50654039&scoped=true&"
import script from "./resultStats.vue?vue&type=script&lang=js&"
export * from "./resultStats.vue?vue&type=script&lang=js&"
import style0 from "./resultStats.vue?vue&type=style&index=0&id=50654039&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50654039",
  null
  
)

export default component.exports